import { render, staticRenderFns } from "./CampaignRecords.vue?vue&type=template&id=044db6a4"
import script from "./CampaignRecords.vue?vue&type=script&lang=js"
export * from "./CampaignRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports